(function ($, Drupal, window) {

  const STACK_KEY = 'term-stack';

  Drupal.behaviors.closeModal = {
    attach: function (context, settings) {
      $(once('js-close-modal', '.js-close-modal', context)).click(function () {
        const mEl = $(this).closest('.modal');

        if (mEl.length) {
          const modal = bootstrap.Modal.getInstance(mEl[0]);
          modal.hide();
        }
      })
    }
  }

  Drupal.behaviors.glossary = {
    attach: function (context, settings) {
      var terms = $(".glossary-list .termlabel").sort();

      if (terms.length) {
        // we are on the glossary page, so remove the back nav
        window.localStorage.removeItem(STACK_KEY);

        // set up the glossary letter filter
        var letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        for (var i = 0; i < letters.length; i++) {
          var nextChar = letters.charAt(i);

          // Need to find first of each letter
          var foundOne = -999;
          for (var j = 0; j < terms.length; j++) {
            var termj = terms[j].innerText;
            var termJJ = termj.toUpperCase();
            if (termJJ.charAt(0) == nextChar) {
              foundOne = j;
              break;
            }
          }


          // Create links and anchors based on whether something was found
          if (foundOne == -999) {

            // Create a new letterLink (with class "nocontent")
            newLetterLink = "<div class=\"letterLinkSpan\"><a class=\"letterLink nocontent\">" + nextChar + "</a></div>";

          } else {

            // Create a new letterLink (with class "hascontent")
            newLetterLink = "<div class=\"letterLinkSpan\"><a class=\"letterLink hascontent\" href=\"#glossar-" + nextChar + "\">" + nextChar + "</a></div>";

          }

          // Either way, add the letterLink to the list of letterLinks
          $("div#glossarlinks").append(newLetterLink).slice(0, 25);
          $('#glossarlinks div:gt(25)').remove();
        }
      }
    }
  }

  Drupal.behaviors.glossaryBack = {
    attach: function (context) {
      $(once('js-glossary-back', '.js-glossary-back', context)).each(function () {
        const el = $(this);
        const stack = JSON.parse(window.localStorage.getItem(STACK_KEY) || '[]');
        const name = $('h1').text();
        const path = window.location.pathname

        if (stack.length) {

          const last = stack[stack.length - 1];

          if (last.name !== name) {
            stack.push({name, path});
          }


          const before = stack.length > 1 ? stack[stack.length -2 ] : null;

          if (before) {
            const btn = $(`<a href="${before.path}" class="btn btn-primary ms-3">Zurück zu ${before.name}</a>`);
            el.append(btn);

            btn.click(function () {
              // drop the current and the before element, as we are going one step back
              stack.pop();
              window.localStorage.setItem(STACK_KEY, JSON.stringify(stack));
            })
          }

        } else {
          stack.push({name, path});
        }

        window.localStorage.setItem(STACK_KEY, JSON.stringify(stack));
      })
    }
  }

})(jQuery, Drupal, window);
